import {createReducer, on} from "@ngrx/store";
import {resetError, setError} from "./error.actions";

export interface State {
    onError: boolean;
    title: string;
    message: string;
    details: string;
}

export const initialState: State = {
    onError: false,
    title: null,
    message: null,
    details: null,
}

export const reducer = createReducer(
    initialState,

    on(resetError, (state: State, action): State => {
        return initialState;
    }),

    on(setError, (state: State, action): State => {
        return {
            ...state,
            title: action.title,
            message: action.message,
            details: action.details,
            onError: true,
        };
    }),
);
